export default __webpack_public_path__ + "static/media/discussionguide.9c10785f.png";